export { LinkHubSpotDealWidget } from './LinkHubSpotDealWidget'
